// Forme ufficiali del brand di Beppe Fasino: quadrato magenta, semi-anello cyan, arco di quarto blu, anello blu.
const CYAN = "#00C2E8";
const MAGENTA = "#E200C8";
const BLUE = "#2020E0";

export const RingFull = ({ className = "", color = BLUE }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="33" fill="none" stroke={color} strokeWidth="22" />
  </svg>
);

export const RingHalf = ({ className = "", color = CYAN }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M50 17 A33 33 0 0 0 50 83" fill="none" stroke={color} strokeWidth="22" />
  </svg>
);

export const RingQuarter = ({ className = "", color = BLUE }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M17 50 A33 33 0 0 1 50 17" fill="none" stroke={color} strokeWidth="22" />
  </svg>
);

export const SquareMagenta = ({ className = "" }) => (
  <div className={`bg-magenta-brand ${className}`} aria-hidden="true" />
);

export const LogoMark = ({ size = 34 }) => (
  <img
    src="/assets/brand-mark.png"
    alt="Logo Giuseppe Fasino"
    width={size}
    height={size}
    className="shrink-0"
  />
);
